module.exports = __webpack_public_path__ + "nc_static/media/sw-update-available.192b244f.svg";